import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { selectIsAuthenticated } from "../../redux/slices/auth/authSelectors";
import { UserRoles } from "../Common/Sidebar";
import { showToast } from "../Toast/Toast";

const OffTrxProtectedRoute = () => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const currentUserDetails = useSelector((state) => state.auth.user) || {};
  const offTrxAccessUsers = useSelector((state) => state.auth.offTrxAccessUsers) || [];
  const location = useLocation();
  const roleName = UserRoles[currentUserDetails?.data?.role?.type];
  const uiid = currentUserDetails?.data?.uiid;

  const isAllowed = roleName === "ADMIN" || offTrxAccessUsers.includes(uiid);

  if (!isAuthenticated)
    return <Navigate to="/login" state={{ from: location }} replace />;
  if (!isAllowed) {
    showToast("You do not have permission to access this module.", "info");
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default OffTrxProtectedRoute;
